import React from 'react';
import BasePage from '@/components/BasePage';
import BaseLayout from '@/components/layouts/BaseLayout';
import { Container, Table } from 'reactstrap';
import Booking from '@/components/Booking';
// Translation Higher Order Component
import { translate } from 'react-switch-lang';

const Kids = ({ t }) => {
	return (
		//React.Fragment is used instead of <div> or <> to hide it from source
		<React.Fragment>
			<BaseLayout
				className="cover"
				title={t('vaccines.kids_programm')}
				description={t('vaccines.kids.text1')}
				keywords={`${t('SEO.keywords_common')} ${t('SEO.keywords_kids')}`}
				canonical="/kids"
			>
				{/* Base Page - Shared component with Container */}
				<BasePage id="vaccines-page" className="vaccines-page pt-5" role="article">
					<Container>
						<article>
							<h1 className="font-weight-bold vaccines-title kids_vaccines">
								{t('vaccines.kids_programm')}
							</h1>
							<hr className="vaccination-page_hr" />
							<p>{t('vaccines.kids.text1')}</p>
							<p>{t('vaccines.kids.text2')}</p>
							<p>{t('vaccines.kids.text3')}</p>
							<p>
								{t('vaccines.kids.text4')} &nbsp;
								<a
									className="country_links inline"
									rel="external nofollow noopener"
									href="https://fmk-online.dk"
									target="_blank"
								>
									www.fmk-online.dk
								</a>.
							</p>

							<Table responsive striped>
								<thead className="page_subtext text-uppercase">
									<tr>
										<th>{t('vaccines.kids.table_age')}</th>
										<th>{t('vaccines.headers.vaccination')}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>3 {t('vaccines.kids.table_month')}</td>
										<td>
											{t('vaccines.kids.table_text1')}
											<sup className="font-weight-bold">2</sup>
										</td>
									</tr>
									<tr>
										<td>
											5 {t('vaccines.kids.table_month')}
											<sup className="font-weight-bold">1</sup>
										</td>
										<td>
											{t('vaccines.kids.table_text2')}
											<sup className="font-weight-bold">2</sup>
										</td>
									</tr>
									<tr>
										<td>
											12 {t('vaccines.kids.table_month')}
											<sup className="font-weight-bold">1</sup>
										</td>
										<td>
											{t('vaccines.kids.table_text3')}
											<sup className="font-weight-bold">2</sup>
										</td>
									</tr>
									<tr>
										<td>15 {t('vaccines.kids.table_month')}</td>
										<td>{t('vaccines.kids.table_text4')} 1</td>
									</tr>
									<tr>
										<td>
											4 {t('vaccines.kids.table_year')}
											<sup className="font-weight-bold">1</sup>
										</td>
										<td>{t('vaccines.kids.table_text4')} 2</td>
									</tr>
									<tr>
										<td>
											5 {t('vaccines.kids.table_year')}
											<sup className="font-weight-bold">1</sup>
										</td>
										<td>{t('vaccines.kids.table_text5')}</td>
									</tr>
									<tr>
										<td>12 {t('vaccines.kids.table_year')}</td>
										<td>{t('vaccines.kids.table_text6')}</td>
									</tr>
								</tbody>
							</Table>
							<p className="text-muted">
								<em>
									<sup className="font-weight-bold">1</sup>
									{t('vaccines.kids.example1')}
									<br />
									<sup className="font-weight-bold">2</sup>
									{t('vaccines.kids.example2')}
								</em>
							</p>
							<hr className="vaccination-page_hr" />
							<p>{t('vaccines.kids.text5')}</p>
						</article>
						<Booking />
					</Container>
				</BasePage>
			</BaseLayout>
		</React.Fragment>
	);
};
export default translate(Kids);
